import React, { useState, useEffect } from 'react';
import { Phone, Mail } from 'lucide-react';
import ScrollReveal from './ScrollReveal';
import { api } from '../services/api';

const DEFAULT_SETTINGS = {
  phone: '+54 11 4567-8900',
  email: 'info@sanzberger.com'
};

const Contact = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    email: '',
    tipoInteres: '',
    mensaje: ''
  });
  const [sending, setSending] = useState(false);
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    api.getSettings().then((data) => {
      if (data) setSettings(data);
    });
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || '/api'}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error('Error al enviar la consulta');
      }

      alert('Consulta enviada correctamente');
      setFormData({
        nombre: '',
        apellido: '',
        email: '',
        tipoInteres: '',
        mensaje: ''
      });
    } catch (error) {
      alert('No se pudo enviar la consulta. Intentá de nuevo en unos minutos.');
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contacto" className="py-24 bg-primary text-primary-foreground relative overflow-hidden">
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
          <ScrollReveal>
            <h2 className="text-4xl md:text-5xl font-bold mb-6">¿Buscas algo específico?</h2>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed">
              Nuestro equipo de asesores expertos está listo para ayudarte a encontrar la propiedad perfecta que se ajuste a tus necesidades y objetivos de inversión.
            </p>

            <div className="space-y-6">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 shrink-0 rounded-full bg-white/10 flex items-center justify-center">
                  <Phone className="w-6 h-6" />
                </div>
                <div className="min-w-0">
                  <p className="text-sm text-gray-400">Llámanos</p>
                  <p className="text-lg sm:text-xl font-semibold break-words">{settings.phone}</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 shrink-0 rounded-full bg-white/10 flex items-center justify-center">
                  <Mail className="w-6 h-6" />
                </div>
                <div className="min-w-0">
                  <p className="text-sm text-gray-400">Escríbenos</p>
                  <p className="text-sm sm:text-xl font-semibold break-all">{settings.email}</p>
                </div>
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={150} className="bg-white rounded-3xl p-5 sm:p-8 text-foreground shadow-2xl">
            <form onSubmit={handleSubmit} className="space-y-3 sm:space-y-4">
              <div className="grid grid-cols-2 gap-3 sm:gap-4">
                <input
                  type="text"
                  name="nombre"
                  placeholder="Nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  className="w-full min-w-0 px-3 sm:px-4 py-2.5 sm:py-3 rounded-xl bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                  required
                />
                <input
                  type="text"
                  name="apellido"
                  placeholder="Apellido"
                  value={formData.apellido}
                  onChange={handleChange}
                  className="w-full min-w-0 px-3 sm:px-4 py-2.5 sm:py-3 rounded-xl bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                  required
                />
              </div>
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-3 sm:px-4 py-2.5 sm:py-3 rounded-xl bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                required
              />
              <select
                name="tipoInteres"
                value={formData.tipoInteres}
                onChange={handleChange}
                className="w-full px-3 sm:px-4 py-2.5 sm:py-3 rounded-xl bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
              >
                <option value="">Tipo de interés</option>
                <option value="compra">Compra</option>
                <option value="venta">Venta</option>
                <option value="alquiler">Alquiler</option>
                <option value="inversion">Inversión</option>
              </select>
              <textarea
                name="mensaje"
                rows="4"
                placeholder="Mensaje"
                value={formData.mensaje}
                onChange={handleChange}
                className="w-full px-3 sm:px-4 py-2.5 sm:py-3 rounded-xl bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
              ></textarea>
              <button
                type="submit"
                disabled={sending}
                className="w-full py-3 sm:py-4 bg-primary text-primary-foreground rounded-xl font-bold hover:bg-primary/90 transition-all shadow-lg shadow-primary/20 disabled:opacity-60"
              >
                {sending ? 'Enviando...' : 'Enviar Consulta'}
              </button>
            </form>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default Contact;